import { useState, useEffect } from "react";
import CustomerService from "../../services/CustomerService";
import { Link, useParams, useNavigate } from "react-router-dom";
import { notification } from "antd";
import { ToastContainer, toast } from "react-toastify";
import {
  UserOutlined,
  LockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import "react-toastify/dist/ReactToastify.css";
import Lodder from "../../components/Lodder";
const ResetPassword = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Reset Password";
  }, []);
  const customerId = useParams().customerId;
  const [submit, setSubmit] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordValidation, setNewPasswordValidation] = useState({
    isValid: false,
    message: "",
  });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordValidation, setConfirmPasswordValidation] = useState({
    isValid: false,
    message: "",
  });
  const ValidateNewPassword = (value) => {
    if (!value.trim()) {
      setNewPasswordValidation({
        isValid: false,
        message: "New Password is required",
      });
    } else if (value.length < 6) {
      setNewPasswordValidation({
        isValid: false,
        message: "Please enter a minimum of 6 characters",
      });
    } else {
      setNewPasswordValidation({
        isValid: true,
        message: "",
      });
    }
  };
  const ValidateConfirmPassword = (value) => {
    if (!value.trim()) {
      setConfirmPasswordValidation({
        isValid: false,
        message: "Confirm Password is required",
      });
    } else if (value !== newPassword) {
      setConfirmPasswordValidation({
        isValid: false,
        message: "New password and confirm password must be same",
      });
    } else {
      setConfirmPasswordValidation({
        isValid: true,
        message: "",
      });
    }
  };
  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
    ValidateNewPassword(event.target.value);
  };
  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    ValidateConfirmPassword(event.target.value);
  };

  const handleFormSubmit = () => {
    setSubmit(false);
    // eslint-disable-next-line no-restricted-globals
    event.preventDefault();
    ValidateNewPassword(newPassword);
    ValidateConfirmPassword(confirmPassword);
    if (newPasswordValidation.isValid && confirmPasswordValidation.isValid) {
      var resetPassword = {
        userId: customerId,
        Newpassword: newPassword,
      };
      CustomerService.ResetPassword(resetPassword)
        .then((response) => {
          if (response.status) {
            /* toast.success("Password changed successfully!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }); */
            /* notification.success({
              message: "Password changed successfully!",
            }); */
            navigate("/resetpasswordconfirmation");
            setSubmit(true);
          }
        })
        .catch((error) => {
          setSubmit(true);
          notification.error({
            message: error.response.data.Message,
          });
        });
    } else {
      setSubmit(true);
    }
  };
  return (
    <>
      <ToastContainer />
      <div className="vh-100 d-flex justify-content-center align-items-center flex-column px-3 login-bg login-form">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12">
              <figure className="text-center mx-auto mb-0">
                {/* <img
                  src="/logo-dark.png"
                  className="img-fluid"
                  alt="foundary logo"
                  style={{ width: 138 }}
                /> */}
              </figure>
            </div>
          </div>
        </div>
        <div className="mx-auto card mt-2 card-width pb-4">
          <div className="card-body">
            <div className="row">
              <div className="col-12 text-center">
                <p className="card-title mb-3 w-100">Reset Password</p>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <form>
                  <input type="hidden" />
                  <div className="mb-3">
                    <label
                      className="form-label custom-label"
                      htmlFor="password"
                    >
                      New Password<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        className="form-control mb-4 custom-input"
                        placeholder=" New Password"
                        type={showNewPassword ? "text" : "password"}
                        value={newPassword}
                        onChange={handleNewPasswordChange}
                        style={{ padding: "0.375rem 2.75rem" }}
                      />
                      <LockOutlined
                        class="fa-solid fa-lock"
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "17px",
                        }}
                      ></LockOutlined>
                      {showNewPassword ? (
                        <EyeOutlined
                          onClick={() => {
                            setShowNewPassword(!showNewPassword);
                          }}
                          style={{
                            position: "absolute",
                            top: "15px",
                            right: "11px",
                          }}
                        />
                      ) : (
                        <EyeInvisibleOutlined
                          onClick={() => {
                            setShowNewPassword(!showNewPassword);
                          }}
                          style={{
                            position: "absolute",
                            top: "15px",
                            right: "11px",
                          }}
                        />
                      )}
                    </div>
                    {!newPasswordValidation.isValid && (
                      <span style={{ color: "red" }}>
                        {newPasswordValidation.message}
                      </span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label
                      className="form-label custom-label"
                      htmlFor="password"
                    >
                      Confirm Password<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        className="form-control  mb-4 custom-input"
                        placeholder="Confirm Password"
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        style={{ padding: "0.375rem 2.75rem" }}
                      />
                      <LockOutlined
                        class="fa-solid fa-lock"
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "17px",
                        }}
                      ></LockOutlined>
                      {showConfirmPassword ? (
                        <EyeOutlined
                          onClick={() => {
                            setShowConfirmPassword(!showConfirmPassword);
                          }}
                          style={{
                            position: "absolute",
                            top: "15px",
                            right: "11px",
                          }}
                        />
                      ) : (
                        <EyeInvisibleOutlined
                          onClick={() => {
                            setShowConfirmPassword(!showConfirmPassword);
                          }}
                          style={{
                            position: "absolute",
                            top: "15px",
                            right: "11px",
                          }}
                        />
                      )}
                    </div>
                    {!confirmPasswordValidation.isValid && (
                      <span style={{ color: "red" }}>
                        {confirmPasswordValidation.message}
                      </span>
                    )}
                  </div>
                </form>
              </div>
            </div>

            {submit ? (
              <button
                type="submit"
                className="btn btn-primary w-100 submit-button  mt-3 mb-3"
                onClick={handleFormSubmit}
              >
                SUBMIT
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-primary w-100 submit-button mb-3"
                onClick={handleFormSubmit}
                disabled
              >
                Submit
              </button>
            )}
            <div className="text-center">
              <Link to="/" className="forgot-link">
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Lodder show={!submit} />
    </>
  );
};
export default ResetPassword;
